
export interface AdminPerms {
    accountAdmin?: boolean;
    createCases?: boolean;
    editCases?: boolean;
    deleteCases?: boolean;
    addEditUsers?: boolean;
    deleteUsers?: boolean;
    changeAccountSettings?: boolean;
    editCaseDataTypes?: boolean;
    addEditParties?: boolean;
    deleteParties?: boolean;
}
export interface AccountPerms {
    createEditEngagementTemplates?: boolean;
    deleteEngagementTemplates?: boolean;
    createEditCaseTemplates?: boolean;
    deleteCaseTemplates?: boolean;
}
export interface CasePerms {
    caseLead?: boolean;
    editCaseInfo?: boolean;
    editEngagement?: boolean;
    viewEngagement?: boolean;
    createMilestones?: boolean;
    editMilestones?: boolean;
    deleteMilestones?: boolean;
    completeMilestones?: boolean;
    reorderMilestones?: boolean;
    reopenMilestones?: boolean;
    viewAllTasks?: boolean;
    createTasks?: boolean;
    createTasksForOthers?: boolean;
    editTasks?: boolean;
    addEvents?: boolean;
    editEvents?: boolean;
    deleteEvents?: boolean;
    addNotes?: boolean;
    viewDocuments?: boolean;
    uploadDocuments?: boolean;
    downloadDocuments?: boolean;
    editDocuments?: boolean;
    deleteDocuments?: boolean;
    addEditTrackedTime?: boolean;
    deleteTrackedTime?: boolean;
    viewExpenses?: boolean;
    addExpenses?: boolean;
    deleteOwnExpenses?: boolean;
    viewBillableRates?: boolean;
    editBillableRates?: boolean;
    viewInvoices?: boolean;
    createInvoices?: boolean;
    deleteInvoices?: boolean;
}
export interface UserPermissions {
    permType?: PermissionType;
    adminPerms?: AdminPerms;
    accountPerms?: AccountPerms;
    casePerms?: CasePerms;
}

export enum PermissionType {
    admin = 'admin',
    caseLead = 'caseLead',
    contributor = 'contrib',
    custom = 'custom'
}